"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuColumn = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./SubMenuColumn.css");
var SubMenuColumn = function (props) {
    var children = props.children, title = props.title, className = props.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-submenu-column', className, !!title && 'dui-submenu-column-title') },
        !!title && react_1.default.createElement("h1", null, title),
        children));
};
exports.SubMenuColumn = SubMenuColumn;
